module.exports = __webpack_public_path__ + "static/media/ic_pull_down.afef4d29.svg";